import { ReactNode } from 'react'
import styled from 'styled-components'

const swatchSize = 13

export const ColorKey = ({
  entries,
  title,
  children,
}: {
  entries?: { color: string; label: string }[]
  title?: string
  children?: ReactNode
}) => {
  return (
    <ColorKeyRoot>
      {title && <Title>{title}</Title>}
      {entries && (
        <Entries>
          {entries.map(({ label, color }, i) => {
            return (
              <Entry key={'colorkey' + i}>
                <Swatch
                  style={{
                    backgroundColor: color,
                  }}
                />
                {label}
              </Entry>
            )
          })}
        </Entries>
      )}
      {children}
    </ColorKeyRoot>
  )
}

const ColorKeyRoot = styled.div`
  position: relative;
  padding: 30px;
  padding-left: 0;
  /* padding-bottom: 30px; */
  top: 0px;
  left: 0%;
  max-width: 300px;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  /* transform: translateX(-50%); */
  background-color: var(--blue-bright-1);
  background-color: var(--site-background);
  /* color: #fff; */
  font-size: 15px;
  letter-spacing: 0.4px;
  @media screen and (max-width: 711px) {
    /* transform: translateX(calc(-50% + 20px)); */
    font-size: 13px;
    max-width: 280px;
    padding: 20px;
  }
`

const Title = styled.div`
  font-weight: 700;
  line-height: 1.6em;
  font-size: 18px;
  text-align: l;
  flex: 0 0 100%;
  @media screen and (max-width: 711px) {
    font-size: 15px;
  }
`

const Entry = styled.div`
  margin-right: 20px;
  display: flex;
  align-items: center;
`
const Entries = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`
const Swatch = styled.div`
  display: inline-block;
  margin-right: 5px;
  width: ${swatchSize}px;
  height: ${swatchSize}px;
  background-color: #f00;
`
